import {Base} from "@/api/Base"

export class AttendancePunchTheClockBackEnd extends Base {
    path = "attendance/punchTheClockBackEnd"
}